module.exports = __webpack_public_path__ + "img/0-14.3d81765a.jpg";